'use strict';

exports.__esModule = true;
exports.loaders = exports.loadAvailabilities = exports.dynamicArgumentsMap = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _widgetActions = require('../actions/widget-actions');

var _constants = require('./constants');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
	Here we specify where to find the arguments to replace in the loaders int the request.
**/
var dynamicArgumentsMap = exports.dynamicArgumentsMap = {
	_profileId_: 'query.profileId'
};

var loadAvailabilities = exports.loadAvailabilities = function loadAvailabilities(specialistId, xhrConfig) {
	return function (dispatch) {
		return _widgetActions.widgetActions.loadSpecialistProfile(specialistId, xhrConfig)(dispatch).then(function () {
			return _widgetActions.widgetActions.loadAvailabilities(specialistId, {}, xhrConfig)(dispatch).then(function (response) {
				var availabilities = response && response.length && response[0];

				// Number of days with availabilities.
				var totalDays = availabilities && availabilities.availabilities && availabilities.availabilities.length;

				if (totalDays) {
					dispatch(_widgetActions.widgetActions.setLatestAvailabilityFound((0, _moment2.default)(availabilities.availabilities[totalDays - 1].start_date)));
				} else {
					var startDate = (0, _moment2.default)().add((0, _utils.getVisibleCalendarDays)(), 'd');
					return _widgetActions.widgetActions.loadAvailabilities(specialistId, {
						startdate: startDate.format('YYYY-MM-DD'),
						enddate: startDate.clone().add(_constants.NEAREST_AVAILABILITY_END_DAYS, 'd').format('YYYY-MM-DD')
					}, xhrConfig)(dispatch).then(function (availabilities) {
						if (availabilities && availabilities.length) {
							dispatch(_widgetActions.widgetActions.setNearestAvailability(availabilities[0].start_date));
						}
					});
				}

				return _promise2.default.resolve();
			});
		});
	};
};

var loaders = exports.loaders = [{
	key: 'widget.availabilities',
	action: loadAvailabilities,
	arguments: ['_profileId_'],
	dynamicArguments: ['_profileId_']
}];